export default {
  names: {
    email: 'E-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    newEmail: 'Nouvelle adresse e-mail',
    confirmEmail: 'Confirmer la nouvelle adresse e-mail',
    newPassword: 'Nouveau mot de passe'
  }
}
